import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { assignPageSelectors } from "../pages/assign";
import {
  findAllAssigns,
  findAssignsByNenki
} from "../services/assigns.service";
import { assignsActions } from "../store/assigns.store";
import { masterAssignsActions } from "../store/master-assigns.store";
import { Assign } from "../types/types";
import { deepCopy, generateUuid } from "../util/util";
import _ from "lodash";

/**
 * システムが全アサインデータを取得する
 */
export function* onSystemFetchAllAssigns() {
  const nenki = yield select(assignPageSelectors.getNenki);
  let assigns: Assign[] = yield call(findAssignsByNenki, nenki);
  assigns = assigns.map(a => {
    if (a.id === 0) {
      a.id = -Number(_.uniqueId());
      a.status = "dummy";
    }
    return a;
  });
  const masterAssigns = deepCopy(assigns);
  yield put(masterAssignsActions.REDUCER_SET_MASTER_ASSIGNS(masterAssigns));
  yield put(assignsActions.REDUCER_SET_ASSIGNS(assigns));
}

/**
 * アサインSaga
 */
export function* assignsSagas() {
  yield all([
    yield takeLatest(
      assignsActions.SYSTEM_FETCH_ALL_ASSIGNS,
      onSystemFetchAllAssigns
    )
  ]);
}
